<template>
  <div>
    <v-navigation-drawer class="main__style" v-model="drawer" dark app color="var(--admin-color)">
      <div class="d-block text-center pt-3 pb-5">
        <p class="white--text text-h5 text-start mb-0 pl-3 font-weight-bold">Murojaatlar
          <!-- <v-avatar color="white" size="24">
            <p class="black--text mb-0 text-caption">{{ person.length }}</p>
          </v-avatar> -->
        </p>
      </div>

      <v-list dense class="py-0">
        <v-list-item-group v-model="selectedItem">
          <v-list-item @click="routerLink('/dashboard')" active-class="white--text" class="py-2 pl-0 pr-4">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 text-start">Dashboard</v-list-item-title>
            </v-list-item-content>
            <!-- <v-list-item-icon>
              <v-avatar color="white" size="24">
                <p class="black--text text-caption mb-0">{{ 0 }}</p>
              </v-avatar>
            </v-list-item-icon> -->
          </v-list-item>

          <v-list-item @click="routerLink('/admin')" active-class="white--text" class="py-2 pl-0 pr-4">
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 text-start">Rahbariyat</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-avatar color="indigo" size="24">
                <p class="white--text text-caption mb-0">{{ rahbariyat }}</p>
              </v-avatar>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item @click="routerLink('/korrupsiya')" class="py-2 pl-0 pr-4">
            <v-list-item-icon class="">
              <v-icon>mdi-currency-usd-off</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 text-start">Korrupsiyaga qarshi</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-avatar color="indigo" size="24">
                <p class="white--text text-caption mb-0">{{ korrupsiya }}</p>
              </v-avatar>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item @click="routerLink('/foydali')" class="py-2 pl-0 pr-4">
            <v-list-item-icon>
              <v-icon>mdi-mine</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 text-start">Foydali qazilma konlari geologiyasi fakulteti</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-avatar color="indigo" size="24">
                <p class="white--text text-caption mb-0">{{ foydali }}</p>
              </v-avatar>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item @click="routerLink('/neft-gaz')" class="py-2 pl-0 pr-4">
            <v-list-item-icon>
              <v-icon>mdi-gas-burner</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 text-start">Neft va gaz konlari geologiyasi fakulteti</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-avatar color="indigo" size="24">
                <p class="white--text text-caption mb-0">{{ neft }}</p>
              </v-avatar>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item @click="routerLink('/boshqalar')" class="py-2 pl-0 pr-4">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2 text-start">Boshqalar</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-avatar color="indigo" size="24">
                <p class="white--text text-caption mb-0">{{ boshqalar }}</p>
              </v-avatar>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="white" dark app>
      <v-app-bar-nav-icon color="var(--admin-color)" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img width="45" src="https://uzgeouniver.uz/storage/user/menus/4/2021-04-28/2021-04-28_1619592726.png">
      <v-spacer></v-spacer>
      <div>
        <div class="d-flex align-center justify-end">
          <!-- <v-btn icon>
            <v-badge :content="newMessage" color="error">
              <v-icon size="25" color="var(--admin-color)">mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn> -->

      <v-menu
        bottom
        min-width="250px"
        rounded
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
          >
          <v-badge :content="newMessage" color="error">
            <v-icon size="25" color="var(--admin-color)">mdi-bell-outline</v-icon>
          </v-badge>
          </v-btn>
        </template>
        <v-card>
          <div class="px-3 pt-6 pb-4" style="font-size: 20px; font-weight: bold;">Yangi murojaatlar</div>
          <v-list v-if="newUnreadMessage" class="px-1">
            <v-list-item-group v-model="model">
              <v-list-item
              class="px-3"
                v-for="(unread, index) in newUnreadMessage"
                :key="index"
              >
                <v-list-item-content @click="findAppeal(unread.send_who)" style="d-flex">
                  <v-list-item-title>
                   {{unread.name}} {{unread.last_name}}
                  </v-list-item-title>
                </v-list-item-content>
                
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list v-else>
            <div class="px-3 py-4" style="font-size: 14px; color:grey; text-align: center;">Ma'lumot topilmadi.</div>
          </v-list>
        </v-card>
      </v-menu>
          <v-btn class="d-none d-md-block" icon><v-icon color="var(--admin-color)">mdi-magnify</v-icon></v-btn>
          <v-btn icon class="mr-2"><v-icon color="var(--admin-color)"> mdi-web</v-icon> </v-btn>
          <v-btn icon class="mr-2" @click="logout()"><v-icon color="var(--admin-color)"> mdi-logout</v-icon> </v-btn>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import person from '@/store/modules/person';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "Navbar",
  data: () => ({
    drawer: true,
    group: null,
    selectedItem: 0,
    model:null
  }),
  created() {
    this.getPerson();
  },
  computed: {
    ...mapGetters("personal", ["person"]),
    newUnreadMessage(){
      let newLists = this.person.filter((x)=>{return x.status == null})
      return newLists;
    },
    newMessage(){
      return this.person.filter((x)=>{return x.status == null}).length
    },
    rahbariyat() {
      let wert = this.person.filter((x) => x.send_who == 'Rahbariyat')
      return wert.length
    },
    korrupsiya() {
      let wert = this.person.filter((x) => x.send_who == 'Korrupsiyaga qarshi')
      return wert.length
    },
    foydali() {
      let wert = this.person.filter((x) => x.send_who == 'Foydali qazilma konlari geologiyasi fakulteti')
      return wert.length
    },
    neft() {
      let wert = this.person.filter((x) => x.send_who == 'Neft va Gaz konlari geologiyasi fakulteti')
      return wert.length
    },
    boshqalar() {
      let wert = this.person.filter((x) => x.send_who == 'Boshqa')
      return wert.length
    },
  },

  methods: {
    ...mapActions("personal", ["getPerson"]),
    routerLink(to) {
      this.$router.push(to);
    },
    routerVirtual(to) {
      this.$router.push(to);
    },
    logout() {
      localStorage.removeItem("userInfo");
      this.$router.push("/");
    },
    findAppeal(vm){
      (vm == 'Boshqa') ? this.$router.push('/boshqalar') : (vm == 'Rahbariyat') ? this.$router.push('/admin') :(vm == 'Korrupsiyaga qarshi') ? this.$router.push('/korrupsiya') : (vm == 'Neft va Gaz konlari geologiyasi fakulteti') ? this.$router.push('/neft-gaz') : this.$router.push('/foydali')
    }

  }
}
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

::v-deep .v-list--dense .v-list-item .v-list-item__icon {
  height: 20px;
  margin: 8px;
}

</style>